/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Rights_Item_Rectification_DescInputs */

const en_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Correct inaccurate personal data`)
};

const de_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) -- Korrigieren Sie ungenaue personenbezogene Daten`)
};

const fr_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) -- Corriger des données personnelles inexactes`)
};

const es_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) -- Corregir datos personales inexactos`)
};

const it_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Correggere dati personali inesatti`)
};

const nl_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Onjuiste persoonlijke gegevens corrigeren`)
};

const pl_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Poprawienie nieprawidłowych danych osobowych`)
};

const fi_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (artikla 16) — Korjaa virheelliset henkilötiedot`)
};

const da_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Ret unøjagtige persondata`)
};

const sv_privacy_rights_item_rectification_desc = /** @type {(inputs: Privacy_Rights_Item_Rectification_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` (Art. 16) — Rätta felaktiga personuppgifter`)
};

/**
* | output |
* | --- |
* | "(Art. 16) — Correct inaccurate personal data" |
*
* @param {Privacy_Rights_Item_Rectification_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_rights_item_rectification_desc = /** @type {((inputs?: Privacy_Rights_Item_Rectification_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Rights_Item_Rectification_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_rights_item_rectification_desc(inputs)
	if (locale === "fr") return fr_privacy_rights_item_rectification_desc(inputs)
	if (locale === "es") return es_privacy_rights_item_rectification_desc(inputs)
	if (locale === "it") return it_privacy_rights_item_rectification_desc(inputs)
	if (locale === "nl") return nl_privacy_rights_item_rectification_desc(inputs)
	if (locale === "pl") return pl_privacy_rights_item_rectification_desc(inputs)
	if (locale === "fi") return fi_privacy_rights_item_rectification_desc(inputs)
	if (locale === "da") return da_privacy_rights_item_rectification_desc(inputs)
	if (locale === "sv") return sv_privacy_rights_item_rectification_desc(inputs)
	return en_privacy_rights_item_rectification_desc(inputs)
});